import { type RouteObject } from 'react-router';
import { DocGenerationAssistantShell } from '../../components/assistant/doc-generation-assistant-shell';
import { RoutesList } from '../../config/routes-list';
import { DocGenerationBetaGuard } from '../guards/doc-generation-beta.guard';
import { lazyRouteNamed } from '../lazy-route';

export const docGenerationRoutes: RouteObject[] = [
  {
    path: RoutesList.DOC_GENERATION_IMPORT,
    element: <DocGenerationBetaGuard />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(
          () => import('../../pages/doc-generation/manual-import/manual-import-page'),
          'ManualImportPage',
        ),
      },
    ],
  },
  {
    path: RoutesList.DOC_GENERATION_DRAFT,
    element: <DocGenerationBetaGuard />,
    children: [
      {
        path: '',
        element: <DocGenerationAssistantShell />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/doc-generation/document-draft-page'),
              'DocumentDraftPage',
            ),
          },
        ],
      },
    ],
  },
];
